<div class="row justify-content-between">
  <div class="col-md col-sm-2">
    <div class="card">
      <div class="card-body p-0 clearfix">
        <i class="fa fa-money-bill bg-primary p-2 font-2xl mr-3 float-left"></i>
        <div class="h6 text-primary mb-0 pt-1">
          {{totals.grossTotal | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
        <div class="text-muted text-uppercase font-weight-bold font-xs">Sub Total</div>
      </div>
    </div>
  </div>
  <div class="col-md col-sm-2">
    <div class="card">
      <div class="card-body p-0 clearfix">
        <i class="fa fa-credit-card bg-primary p-2 font-2xl mr-3 float-left"></i>
        <div class="h6 text-primary mb-0 pt-1">
          {{totals.discountTotal | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
        <div class="text-muted text-uppercase font-weight-bold font-xs">Descuento</div>
      </div>
    </div>
  </div>
  <div class="col-md col-sm-2">
    <div class="card">
      <div class="card-body p-0 clearfix">
        <i class="fa fa-money-bill-transfer bg-primary p-2 font-2xl mr-3 float-left"></i>
        <div class="h6 text-primary mb-0 pt-1">
          {{totals.grossTotalWithDiscount | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
        <div class="text-muted text-uppercase font-weight-bold font-xs">Sub-Total con Descuento</div>
      </div>
    </div>
  </div>
  <div class="col-md col-sm-2">
    <div class="card">
      <div class="card-body p-0 clearfix">
        <i class="fa fa-info bg-warning p-2 font-2xl mr-3 float-left"></i>
        <div class="h6 text-primary mb-0 pt-1">
          {{totals.taxTotal | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
        <div class="text-muted text-uppercase font-weight-bold font-xs">Impuesto</div>
      </div>
    </div>
  </div>

  <div class="col-md col-sm-2">
    <div class="card">
      <div class="card-body p-0 clearfix">
        <i class="fa fa-shopping-cart bg-success p-2 font-2xl mr-3 float-left"></i>
        <div class="h6 text-primary mb-0 pt-1">
          {{totals.netTotal | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
        <div class="text-muted text-uppercase font-weight-bold font-xs">Total</div>
      </div>
    </div>
  </div>
</div>